"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STREAMING_CHAINS_NAME_PATTERN = exports.QUANTITY_CHAIN_RECORDS_TO_REQUEST = exports.Event = void 0;
const types_1 = require("@refinitiv-data/types");
exports.Event = types_1.Pricing.Chain.Event;
exports.QUANTITY_CHAIN_RECORDS_TO_REQUEST = types_1.Pricing.Chain.QUANTITY_CHAIN_RECORDS_TO_REQUEST;
exports.STREAMING_CHAINS_NAME_PATTERN = types_1.Pricing.Chain.STREAMING_CHAINS_NAME_PATTERN;
__exportStar(require("./definition"), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29udGVudC9wcmljaW5nL2NoYWluL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsaURBQWdEO0FBUW5DLFFBQUEsS0FBSyxHQUFHLGVBQU8sQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDO0FBQzVCLFFBQUEsaUNBQWlDLEdBQUcsZUFBTyxDQUFDLEtBQUssQ0FBQyxpQ0FBaUMsQ0FBQztBQUNwRixRQUFBLDZCQUE2QixHQUFHLGVBQU8sQ0FBQyxLQUFLLENBQUMsNkJBQTZCLENBQUM7QUFFekYsK0NBQTZCIn0=